import { Component, ElementRef, EventEmitter, Input, Output, ViewChild
       } from '@angular/core';

import { TextConstants } from 'app/text/text.constants';

@Component({
  selector: 'text-size-chooser',
  templateUrl: './text-size-chooser.component.html',
  styleUrls: [ './text-size-chooser.component.scss' ],
})
export class TextSizeChooserComponent
{
  @Input('minFontSize') public minFontSize: number =
      TextConstants.MIN_FONT_SIZE;
  @Input('enabled') public enabled: boolean = false;
  @Output() public fontSizeChange: EventEmitter<number> = new EventEmitter();
  public _fontSize: number = 0;

  @ViewChild('input') private input: ElementRef;

  @Input('fontSize') public set fontSize(value: number)
  {
    this._fontSize = Math.round(value);
  }

  public resetInputField(): void
  {
    this.input.nativeElement.value = this._fontSize;
  }

  public setEncodedFontSize(encodedFontSize: string): void
  {
    const size = parseInt(encodedFontSize, 10);

    if (!isNaN(size)) {
      this.setFontSize(size);
    } else {
      this.setFontSize(this._fontSize);
    }
  }

  public increaseFontSize(event): void
  {
    this.changeFontSize(event, 1.1);
  }

  public decreaseFontSize(event): void
  {
    this.changeFontSize(event, 0.9);
  }

  private changeFontSize(event, factor): void
  {
    event.preventDefault();
    this.setFontSize(this._fontSize * factor);
  }

  private setFontSize(size: number): void
  {
    this.fontSizeChange.emit(Math.round(size));
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/text-editing/text-size-chooser.component.ts